import { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import agentApiService from '../services/agentApiService';

export const useHotelDetails = (hotelId, provider, searchId) => {
  const [loading, setLoading] = useState(true);
  const [hotelDetails, setHotelDetails] = useState(null);
  const [isProfileComplete, setIsProfileComplete] = useState(false);
  const [timerKey, setTimerKey] = useState('');
  const [expiryTime, setExpiryTime] = useState(0);
  const [roomWiseCancellationPolicy, setRoomWiseCancellationPolicy] = useState({});
  const [error, setError] = useState(null);

  const fetchHotelDetails = useCallback(async () => {
    if (!hotelId || !provider || !searchId) {
      setError('Missing required parameters');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      console.log('🏨 Fetching hotel details:', { hotelId, provider, searchId });

      const response = await agentApiService.getHotelDetails(hotelId, provider, searchId);

      if (response.success) {
        setHotelDetails(response.hotelDetails);
        setIsProfileComplete(response.isProfileComplete);
        setTimerKey(response.timerKey);
        setExpiryTime(response.expiryTime);
        setRoomWiseCancellationPolicy(response.roomWiseCancellationPolicy || {});
        
        console.log('✅ Hotel details loaded successfully');
      } else {
        throw new Error(response.message || 'Failed to fetch hotel details');
      }
    } catch (error) {
      console.error('❌ Error fetching hotel details:', error);
      setError(error.message);
      toast.error(`Failed to load hotel details: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }, [hotelId, provider, searchId]);

  useEffect(() => {
    fetchHotelDetails();
  }, [fetchHotelDetails]);

  const refetch = useCallback(() => {
    fetchHotelDetails();
  }, [fetchHotelDetails]);

  return {
    loading,
    hotelDetails,
    isProfileComplete,
    timerKey,
    expiryTime,
    roomWiseCancellationPolicy,
    error,
    refetch
  };
};